import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { ScrapType } from './Scrap';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
    DataContext.register([
        {
            name: "BOARD_TODAY_OUTPUT",
            data: BOARD_TODAY_OUTPUT
        },
        {
            name: "BOARD_TODAY_DEFECT",
            data: BOARD_TODAY_DEFECT
        },
        {
            name: "BOARD_TODAY_SPEED",
            data: BOARD_TODAY_SPEED
        },
        {
            name: "BOARD_TODAY_DONUT",
            data: BOARD_TODAY_DONUT
        },
    ]);
}

const BOARD_TODAY_SPEED = [
    [
        [4750, 4500, 5120, 5500, 5300, 5231, 5500],
        [230, 265, 255, 240, 261, 258, 270]
    ]
];

const BOARD_TODAY_OUTPUT = [
    [
        [160, 160, 160, 160, 160],
        [77, 75, 76, 74, 78],
        [75, 73, 75, 71, 75],
        [0.974, 0.987, 0.993, 0.987, 0.980]
    ]
];

const BOARD_TODAY_DEFECT = [
    [
        [3, 2, 1, 2, 3],
        [0.0020, 0.0052, 0.0064, 0.0034, 0.0056]
    ]
];


const BOARD_TODAY_DONUT = [
    [
        { name: "启停", value: 0.17, color: theme.color.danger, type: ScrapType.other },
        { name: "甘油", value: 0.12, color: theme.color.warning, type: ScrapType.other },
        { name: "圆周", value: 0.06, color: theme.color.pink, type: ScrapType.other },
        { name: "接纸", value: 0.14, color: theme.color['m-primary'], type: ScrapType.other },
        { name: "少珠", value: 0.16, color: theme.color.info, type: ScrapType.video },
        { name: "多珠", value: 0.04, color: theme.color.secondaryDark, type: ScrapType.video },
        { name: "相位", value: 0.15, color: theme.color['r-green'], type: ScrapType.video },
        { name: "色差", value: 0.05, color: theme.color['r-orange'], type: ScrapType.video },
        { name: "接头", value: 0.03, color: theme.color['light-blue'], type: ScrapType.video },
        { name: "破损", value: 0.08, color: theme.color['grey-system'], type: ScrapType.video }
    ]
];